(function() {
    angular
        .module('app')
        .directive('gMaps', gMaps);

    gMaps.$inject = ['$timeout', '$parse', '$window','mapsService','$filter'];

    function gMaps($timeout, $parse, $window,mapsService,$filter) {
        return {
            restrict: 'A',
            link: function(scope, element, $attrs,rootScope) {

                return $timeout(function() {
                    //Attribute definitions
                    var value = $attrs.value,
                        $element = $(element),
                        id = $attrs.id;
                        //Elimina el benvinguts al clickar en el mapa
                        element.on('click',function(){
                           // alert("hola");
                            $timeout(function(){
                                mapsService.begin();
                            },0);
                        });

					var	map = new google.maps.Map(document.getElementById(id), {
  								
  								
						});
            
					
                    mapsService.setGmaps(map);

                    var controlDiv = document.createElement('div');
                    var controlDivbottoM = document.createElement('div');

                    function addYourLocationButton (map) 
                    {
                    
                        var firstChild = document.createElement('button');
                        firstChild.style.backgroundColor = '#fff';
                        firstChild.style.border = 'none';
                        firstChild.style.outline = 'none';
                        firstChild.style.width = '25px';
                        firstChild.style.height = '25px';
                        firstChild.style.cursor = 'pointer';
                        firstChild.style.marginRight = '13px';
                        firstChild.style.padding = '0';
                        firstChild.title = 'Geolocation';
                        controlDiv.appendChild(firstChild);
                    
                        var secondChild = document.createElement('div');
                        secondChild.style.margin = '3px 3px';
                        secondChild.style.width = '18px';
                        secondChild.style.height = '18px';
                        secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-2x.png)';
                        secondChild.style.backgroundSize = '180px 18px';
                        secondChild.style.backgroundPosition = '0 0';
                        secondChild.style.backgroundRepeat = 'no-repeat';
                        firstChild.appendChild(secondChild);
                    
                        google.maps.event.addListener(map, 'center_changed', function () {
                            secondChild.style['background-position'] = '0 0';
                        });
                    
                        firstChild.addEventListener('click', function () {
                            mapsService.geolocation();
                        });
                    
                        //controlDiv.index = 1;
                        //map.controls[google.maps.ControlPosition.RIGHT_TOP].push(controlDiv);
                    }



                     function CenterControl(controlDiv, map ,name,lat,long,zoom) {
                             var chicago = {lat: lat, lng: long};

                             // Set CSS for the control border.
                             var controlUI = document.createElement('div');
                             controlUI.style.backgroundColor = '#fff';
                             controlUI.style.border = '2px solid #fff';
                             controlUI.style.borderRadius = '3px';
                             controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
                             controlUI.style.cursor = 'pointer';
                             controlUI.style.marginBottom = '4px';
                             controlUI.style.marginRight = '4px';
                             controlUI.style.textAlign = 'center';
                             controlUI.title = name;
                             controlDiv.appendChild(controlUI);

                             // Set CSS for the control interior.
                             var controlText = document.createElement('div');
                             controlText.style.color = 'rgb(25,25,25)';
                             controlText.style.fontFamily = 'Arial,sans-serif';
                             controlText.style.fontSize = '11px';
                             controlText.style.paddingLeft = '5px';
                             controlText.style.paddingRight = '0px';
                             controlText.innerHTML = name;
                             controlUI.appendChild(controlText);

                             // Setup the click event listeners: simply set the map to Chicago.
                             controlUI.addEventListener('click', function() {
                               map.setCenter(chicago);
                               map.setZoom(zoom);
                             });

                    }
                    var centerControl = new CenterControl(controlDivbottoM, map,$filter('translate')("Països Catalans"),41.387016,2.170047,7);
                    var centerControl = new CenterControl(controlDivbottoM, map,$filter('translate')("Europa"),48.864716,2.349014,5);
                    var centerControl = new CenterControl(controlDivbottoM, map,$filter('translate')("Món"), 12.733627841099999, -58.19249760934997,3);
                    
                    
                    addYourLocationButton(map);

                    controlDiv.index = 1;
                    controlDivbottoM.index = 2;
                    
                    map.controls[google.maps.ControlPosition.RIGHT_TOP].push(controlDiv);
                    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDivbottoM);




                    //Autocompletado de GOOGLE
                    var input = /** @type {!HTMLInputElement} */(
                    document.getElementById('territori'));
                    mapsService.autocomplete = new google.maps.places.Autocomplete(input);
                    mapsService.autocomplete.bindTo('bounds', map);
                    mapsService.autocomplete.addListener('place_changed', function() {
                        mapsService.eventPan = true;
                        var place = mapsService.autocomplete.getPlace();
                        if (!place.geometry) {
                        // User entered the name of a Place that was not suggested and
                            // pressed the Enter key, or the Place Details request failed.
                            window.alert("No details available for input: '" + place.name + "'");
                            return;
                        }
                        console.log(place);
                        // If the place has a geometry, then present it on a map.
                        if (place.geometry.viewport) {
                            map.fitBounds(place.geometry.viewport);
                        } else {
                            map.setCenter(place.geometry.location);
                            map.setZoom(17);  // Why 17? Because it looks good.
                        }
                    });

                });

            }
        };
    }

})();
